var _style, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "clock-1",
    className: "st0 fill-selector",
    points: "156.6,87 156.6,149.2 209.9,182.6 196.6,202.6 134.3,162.5 134.3,87 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clock-2",
    className: "st0 fill-selector",
    d: "M146.1,22.3c-69.3,0-125.5,56.2-125.5,125.5s56.2,125.5,125.5,125.5s125.5-56.2,125.5-125.5 S215.4,22.3,146.1,22.3z M146.6,248.7c-56,0-101.4-45.4-101.4-101.4S90.6,45.9,146.6,45.9S248,91.3,248,147.3 S202.6,248.7,146.6,248.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.19d106175edba432463aad586b2be4fd.svg";
export { ForwardRef as ReactComponent };